module.exports = __webpack_public_path__ + "site-build/img/banner@2.8a260cad.png";